export default __webpack_public_path__ + "static/media/sharepoint1.082dde82.png";